export enum RolesEnum {
  Teacher = 'teacher',
  Student = 'student',
  Schooladmin = 'schooladmin',
}
